import React from 'react';
import { Box, Grid, Paper, Typography, LinearProgress } from '@mui/material';
import { trakrefFontFamily } from '../../../utils';
import { Grey1, trakrefBlue } from '../../../color_utils';

const formatNumber = (value, decimals = 2) => {
    if (value === null || value === undefined) return '-';
    return value.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};

const MetricCard = ({ label, value, loading }) => (
    <Paper
        variant="outlined"
        sx={{
            p: 2,
            height: 60,
            borderColor: '#E3E8EB',
            borderRadius: 2,
            position: 'relative',
            overflow: 'hidden',
        }}
    >
        {loading && (
            <LinearProgress
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: trakrefBlue,
                    },
                }}
            />
        )}
        <Typography
            variant="caption"
            sx={{
                color: Grey1,
                fontFamily: trakrefFontFamily,
                fontWeight: 500,
                display: 'block',
                mb: 0.5,
            }}
        >
            {label}
        </Typography>
        <Typography
            variant="h5"
            sx={{
                fontFamily: trakrefFontFamily,
                fontWeight: 400,
            }}
        >
            {value}
        </Typography>
    </Paper>
);

const SummaryTable = ({ data, loading = false }) => {
    const metrics = [
        { label: 'Total Start Weight (lbs)', value: formatNumber(data.startWeightLbs, 0) },
        { label: 'Total Start Weight (Mt)', value: formatNumber(data.startWeightMt, 4) },
        { label: 'Total End Weight (lbs)', value: formatNumber(data.endWeightLbs, 0) },
        { label: 'Total End Weight (Mt)', value: formatNumber(data.endWeightMt, 4) },
        { label: 'Total Difference (lbs)', value: formatNumber(data.differenceLbs, 0) },
        { label: 'Total Difference (Mt)', value: formatNumber(data.differenceMt, 4) },
        { label: 'Total Potential Emissions (MtCO₂e)', value: formatNumber(data.potentialEmissions, 4) },
    ];

    return (
        <Box sx={{ mb: 4 }}>
            <Grid container spacing={2}>
                {/* First row - 5 cards */}
                {metrics.slice(0, 5).map((metric, index) => (
                    <Grid item xs={12} sm={6} md={2.4} key={index}>
                        <MetricCard label={metric.label} value={metric.value} loading={loading} />
                    </Grid>
                ))}
            </Grid>
            <Grid container spacing={2} sx={{ mt: 0 }}>
                {/* Second row - 2 cards */}
                {metrics.slice(5).map((metric, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                        <MetricCard label={metric.label} value={metric.value} loading={loading} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SummaryTable;
